import { FC } from "react";
import { YesNoFormField } from "@blanket/components/formFields/FormFields";
import {
  isIneligiblePartnerExam,
  requiresPartnerExamField,
} from "../../eligibility/participantEligibilityRules";
import { NOT_ELIGIBLE_PARTNER_EXAM_TEXT } from "../../eligibility/participantEligibilityUi";

type PartnerExamEligibilityFieldsProps = {
  namePrefix: string;
  idPrefix: string;
  isLawyerOrLawFirm: string;
  passedPartnerExam: string;
  label: string;
  ineligibleTitle: string;
};

export const PartnerExamEligibilityFields: FC<
  PartnerExamEligibilityFieldsProps
> = ({
  namePrefix,
  idPrefix,
  isLawyerOrLawFirm,
  passedPartnerExam,
  label,
  ineligibleTitle,
}) => {
  if (!requiresPartnerExamField(isLawyerOrLawFirm)) {
    return null;
  }

  return (
    <>
      <YesNoFormField
        name={`${namePrefix}.passedPartnerExam`}
        label={label}
        isRequired
        id={`${idPrefix}-passed-partner-exam`}
      />
      {isIneligiblePartnerExam(passedPartnerExam) && (
        <>
          <p className="small fw-semibold text-muted">{ineligibleTitle}</p>
          <p className="small text-muted text-wrap">
            {NOT_ELIGIBLE_PARTNER_EXAM_TEXT}
          </p>
        </>
      )}
    </>
  );
};
